import React from 'react';
import { Phone, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black">
      {/* Background with subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-950/30 via-black to-purple-950/30 -z-10"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-cyan-500/10 rounded-full opacity-20 blur-3xl -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-500/10 rounded-full opacity-20 blur-3xl -z-10"></div>

      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
                {mockData.hero.headline}
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed">
                {mockData.hero.subheadline}
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg"
                className="bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
                onClick={() => {
                  document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
                  setTimeout(() => {
                    document.querySelector('#name')?.focus();
                  }, 1000);
                }}
              >
                <Calendar className="w-5 h-5 mr-2" />
                Schedule a Ride
              </Button>
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-cyan-500 text-cyan-600 hover:bg-cyan-50 text-lg px-8 py-6 transition-all"
                onClick={() => window.location.href = `tel:${mockData.company.phone.replace(/\D/g, '')}`}
              >
                <Phone className="w-5 h-5 mr-2" />
                {mockData.hero.cta.secondary}
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 pt-8 border-t border-gray-800">
              {mockData.stats.map((stat, index) => (
                <div key={index} className="text-center sm:text-left">
                  <div className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">{stat.number}</div>
                  <div className="text-sm text-gray-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_cck-transport-hub/artifacts/75jvzesc_454c444f-09fd-4040-b7e8-91f7be78516d.jpeg"
                alt="CCK Possibilities fleet of medical transportation vehicles"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-900/30 to-transparent"></div>
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-6 -left-6 bg-gray-900 border border-gray-800 rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-start space-x-4">
                <div className="bg-green-500/20 rounded-full p-3">
                  <Phone className="w-6 h-6 text-green-400" />
                </div>
                <div>
                  <div className="font-semibold text-white">24/7 Support</div>
                  <div className="text-sm text-gray-400">Available anytime you need us</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
